export class Status {
    public id: number;
    public description: string;

    constructor(id?: number, description?: string) {
        if (id && description) {
            this.id = id;
            this.description = description;
        }
    }
}